module.exports = __webpack_public_path__ + "img/ccdscontacttop.bcf0349c.png";